import { render, staticRenderFns } from "./SideMenuCard.vue?vue&type=template&id=c318feae&scoped=true&"
import script from "./SideMenuCard.vue?vue&type=script&lang=js&"
export * from "./SideMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuCard.vue?vue&type=style&index=0&id=c318feae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c318feae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VIcon,VRow})
